import { createFileRoute } from "@tanstack/react-router";
import Left from "@repo/icons/default/Left";
import { graphql } from "@repo/graphql-types/gql";
import { useGraphQL } from "@/hooks/use-graphql";
import {
  HeaderButton,
  HeaderRoot,
  HeaderTitle,
} from "@/components/ui/layout/header/header";
import { Page } from "@/components/ui/layout/page/page";
import { AsyncDataWrapper } from "@/components/ui/async-data-wrapper";
import { BillingItemAppointmentDetailsContainer } from "@/components/billing/details/billing-item-details-appointment-container";
import { BillingItemAssistDetailsContainer } from "@/components/billing/details/billing-item-details-assist-container";
import { BillingItemDetailsDefaultContainer } from "@/components/billing/details/billing-item-details-default-container";

import type { JSX } from "react";

// biome-ignore lint/plugin/route-file-exports: predates the rule; move it out
export const BillingDetailsQuery = graphql(/* GraphQL */ `
  query BillingDetailsQuery($billingItemId: Int!) {
    billingItem: movimentacaoDetalhada(codMovimentacao: $billingItemId) {
      ...BillingItemDetailsQueryFragment
    }
  }
`);

export interface BillingItemRouteParams {
  appointmentId: string;
}

const NewBillingItemDetailsPage = (): JSX.Element => {
  const { appointmentId, assistBillingBatchId } = Route.useSearch();
  const { billingItemId } = Route.useParams();

  const billingQueryResult = useGraphQL(BillingDetailsQuery, {
    billingItemId: Number(billingItemId),
  });

  const { data } = billingQueryResult;

  return (
    <>
      <HeaderRoot>
        <HeaderButton icon={Left} align="start" />
        <HeaderTitle title="Histórico de uso" align="center" />
      </HeaderRoot>
      <Page>
        <AsyncDataWrapper {...billingQueryResult}>
          {billingQueryResult.data?.billingItem ? (
            <>
              {appointmentId && data?.billingItem ? (
                <BillingItemAppointmentDetailsContainer billingData={data.billingItem} />
              ) : null}

              {assistBillingBatchId && data?.billingItem ? (
                <BillingItemAssistDetailsContainer billingData={data.billingItem} />
              ) : null}

              {!appointmentId && !assistBillingBatchId && data?.billingItem ? (
                <BillingItemDetailsDefaultContainer billingData={data.billingItem} />
              ) : null}
            </>
          ) : null}
        </AsyncDataWrapper>
      </Page>
    </>
  );
};

export const Route = createFileRoute("/settings/billing/$billingItemId")({
  component: NewBillingItemDetailsPage,
});
